import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import React, { forwardRef, useEffect, useState } from 'react';

interface SafeHtmlProps extends React.HTMLAttributes<HTMLDivElement> {
    html: string;
}

const SafeHtml = forwardRef<HTMLDivElement, SafeHtmlProps>(
    ({ html, ...props }, ref) => {
        const [sanitizedHtml, setSanitizedHtml] = useState(html);

        useEffect(() => {
            // 클라이언트 사이드에서만 DOMPurify 실행
            if (typeof window !== 'undefined') {
                const sanitized = DOMPurify.sanitize(html);
                setSanitizedHtml(sanitized);
            }
        }, [html]);

        return (
            <div ref={ref} {...props}>
                {parse(sanitizedHtml || '')} {/* 값이 빈 문자열이라도 정상 작동 */}
            </div>
        );
    }
);

SafeHtml.displayName = 'SafeHtml';

export default SafeHtml;
